import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite'
import { COLOR_BLACK, COLOR_WHITE } from '../../lib/colors'
import { SPACE } from '../../lib/spaces'
import UIButtonIcon from '../UI/UIButtonIcon'
import IconClose from '../Icon/IconClose'
import IconPreviousPage from '../Icon/IconPreviousPage'
import { useEffect } from 'react'

const LayoutModal = ({
  children,
  isOpened,
  headerLabel,
  hasPadding = true,
  onClose,
  hasReturn,
  onReturn,
  dynamicStyle,
  elementStyle,
  customStyle,
}) => {
  useEffect(() => {
    if (isOpened) {
      document.body.style.overflow = 'hidden'
    }
    return () => (document.body.style.overflow = 'unset')
  }, [isOpened])

  return (
    <div className={css(dynamicStyle)}>
      {isOpened &&
        ReactDOM.createPortal(
          <div className={css(styles.overlay)}>
            <div className={css(styles.container)}>
              <div className={css(styles.modal, customStyle && customStyle)}>
                {!!headerLabel && (
                  <div className={css(styles.modalHeader)}>{headerLabel}</div>
                )}
                {hasReturn ? (
                  <span className={css(styles.returnContainer)}>
                    <UIButtonIcon onClick={onReturn}>
                      <IconPreviousPage color="black" />
                    </UIButtonIcon>
                  </span>
                ) : (
                  <></>
                )}
                <span className={css(styles.closeContainer)}>
                  <UIButtonIcon onClick={onClose}>
                    <IconClose />
                  </UIButtonIcon>
                </span>
                <div
                  className={css(
                    elementStyle && styles.center,
                    hasPadding && styles.withPadding
                  )}
                >
                  {children}
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  )
}

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 40,
    width: '100vw',
    height: '100vh',
    backgroundColor: `${COLOR_BLACK}80`,
  },
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 50,
    width: '100%',
    height: '100%',
    outline: 0,
    display: 'flex',
    alignItems: 'center',
    paddingTop: SPACE,
    paddingBottom: SPACE,
  },
  modal: {
    zIndex: 60,
    background: COLOR_WHITE,
    position: 'relative',
    margin: 'auto',
    borderRadius: 6,
    maxWidth: 500,
    maxHeight: 'calc(100vh - 50px)',
    overflow: 'scroll',
    width: '80%',
    '@media (max-width: 480px)': {
      width: '90%',
    },
  },
  closeContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 1,
  },
  returnContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  modalHeader: {
    padding: SPACE,
    textAlign: 'center',
    boxShadow: '0 10px 16px 0 #32324733',
    textTransform: 'uppercase',
    fontSize: 14,
    fontWeight: 600,
    '@media (max-width: 480px)': {
      fontSize: 12,
      paddingLeft: '50px',
      paddingRight: '50px',
    },
  },
  withPadding: {
    padding: '1.5em 3em',
    '@media (max-width: 480px)': {
      padding: '1.5em 1.2em',
    },
  },
  center: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '20px',
  },
})

LayoutModal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpened: PropTypes.bool,
  headerLabel: PropTypes.string,
  hasPadding: PropTypes.bool,
  onClose: PropTypes.func,
  hasReturn: PropTypes.bool,
  onReturn: PropTypes.func,
  dynamicStyle: PropTypes.object,
  customStyle: PropTypes.object,
  elementStyle: PropTypes.bool,
}

export default LayoutModal
